import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router';
import { Count } from 'barnyard/components';
import { NO_RECEIPTS_VALUE } from '~/app/common/constants/Receivables';
import AlertItem from './AlertItem';


const OrderUnreceivedAlert = ({ alert, ...other }) => {
  const numberOrders = alert.value.count;
  const { start_date, end_date } = alert.value;
  return (
    <AlertItem
      alert={alert}
      date={moment(alert.date).format('MMMM Do, YYYY')}
      icon='cubes'
      title={(
        <div>
          <strong>
            <Link
              to={`/corporate/history/orders/?received_status=${NO_RECEIPTS_VALUE}&start_date=${start_date}&end_date=${end_date}`}
            >
              <Count count={numberOrders} singular='order' />
            </Link> {' '}
          </strong> created between {' '}
          <strong>
            {moment(start_date).format('MMMM Do, YYYY')}
          </strong>
          {' '} and {' '}
          <strong>
            {moment(end_date).format('MMMM Do, YYYY')}
          </strong>
          {' '} {numberOrders > 1 ? 'have' : 'has' } been unreceived.
        </div>
      )}
      {...other}
    />
  );
};

OrderUnreceivedAlert.propTypes = {
  alert: PropTypes.object.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired
};

export default OrderUnreceivedAlert;
